import React, { useEffect } from 'react';

interface SuccessToastProps {
    message: string;
    clearSuccess: () => void;
}

const SuccessToast: React.FC<SuccessToastProps> = ({ message, clearSuccess }) => {
    useEffect(() => {
        if (!message) return;

        const timer = setTimeout(() => {
            clearSuccess();
        }, 5000);

        return () => clearTimeout(timer);
    }, [message, clearSuccess]);

    if (!message) return null;

    return (
        <div
            role="status"
            className="fixed top-16 right-4 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg max-w-sm z-50"
        >
            <p>{message}</p>
        </div>
    );
};

export default SuccessToast;